import { render, staticRenderFns } from "./404.vue?vue&type=template&id=4555e2f2&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"
import style0 from "./404.vue?vue&type=style&index=0&id=4555e2f2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4555e2f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4555e2f2')) {
      api.createRecord('4555e2f2', component.options)
    } else {
      api.reload('4555e2f2', component.options)
    }
    module.hot.accept("./404.vue?vue&type=template&id=4555e2f2&scoped=true", function () {
      api.rerender('4555e2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/404.vue"
export default component.exports